import React, { useEffect, useState } from 'react';
import { fetchSkills } from '../api';

const SkillsTable = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchSkills()
      .then(res => {
        setData(res.data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="container-fluid mt-4 px-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="text-black fw-bold">Skill Development Enquiries</h4>
        <span className="badge bg-secondary">{data.length} Records Found</span>
      </div>

      {isLoading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p className="mt-2 text-muted">Loading Data...</p>
        </div>
      ) : (
        <div className="table-responsive shadow-sm rounded">
          <table className="table table-hover table-striped table-bordered align-middle mb-0">
            <thead className="table-dark text-center align-middle">
              <tr>
                <th>ID</th>
                <th>Full Name</th>
                <th>Guardian Name</th>
                <th>Preference</th>
                <th>Date of Birth</th>
                <th>Gender</th>
                <th>Mobile Number</th>
                <th>State</th>
                <th>City / District</th>
                <th>Address</th>
                <th>Education</th>
                <th>Category</th>
                <th>Submission Date</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.id || index}>
                    <td className="text-center fw-bold">{index + 1}</td>
                    
                    {/* Basic Info */}
                    <td className="fw-semibold">{item.name}</td>
                    <td>{item.guardianName || '-'}</td>
                    <td>
                      <span className="badge bg-primary text-white">{item.preference}</span>
                    </td>
                    
                    {/* Personal Details */}
                    <td className="text-center">
                      {item.dateOfBirth ? new Date(item.dateOfBirth).toLocaleDateString() : '-'}
                    </td>
                    <td>{item.gender}</td>
                    
                    {/* Contact */}
                    <td className="text-center">
                      <a href={`tel:${item.mobileNumber}`} className="text-decoration-none fw-bold">
                        {item.mobileNumber}
                      </a>
                    </td>

                    {/* Location */}
                    <td>{item.state || '-'}</td>
                    <td>{item.district || item.city || '-'}</td>
                    <td>
                       <span className="d-inline-block text-truncate" style={{maxWidth: '150px'}} title={item.address}>
                         {item.address || '-'}
                       </span>
                    </td>

                    {/* Education & Category */}
                    <td>{item.education}</td>
                    <td>
                      <span className="badge bg-warning text-dark">{item.category}</span>
                    </td>

                    {/* Date */}
                    <td className="text-center small text-muted">
                      {item.submissionDate ? new Date(item.submissionDate).toLocaleString() : '-'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="text-center py-4 text-muted">
                    No skill development enquiries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SkillsTable;